import styled from 'styled-components';

const Layout = styled.div`
    position: relative;
    width: ${props => (props.body && !props.hero ? props.theme.width.lrg : '100%')};
    max-width: 100%;
    min-height: ${({ theme, body, flex }) => (body && !flex ? '100vh' : '100%')};
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: ${({ center }) => (center ? 'center' : 'inherit')};
    align-items: ${({ center }) => (center ? 'center' : 'inherit')};
    margin: 0 auto;
    padding-top: ${({ theme, nav }) => nav ? theme.navbar.lrg : 'none'};
    box-sizing: border-box;
    /* overflow-x: hidden; */
    flex: 1 0 0%;
    color: ${({ theme, color }) => (color ? theme.color[color] : 'inherit')};
`;
const Flex = styled.div`
    ${({ flex }) => flex && `flex: ${flex};`};
    width: 100%;
    display: flex;
    padding: ${({ theme, padding }) => theme.padding[padding]};
    margin: ${({ margin }) => margin || 0};
    box-sizing: border-box;
    justify-content: ${({ justify }) => justify || 'flex-start'};
    align-items: ${({ align }) => align || 'flex-start'};
    flex-wrap: ${({ wrap }) => wrap ? 'wrap' : 'nowrap'};
`;
const Vertical = styled(Flex)`
    flex-direction: column;
    min-height: 1px;
`;
const Horizontal = styled(Flex)`
    flex-direction: row;
    align-items: stretch;
`;
const Reduced = styled(Layout)`
    width: ${({ width }) => width || '800px'};
    min-height: fit-content;
    height: fit-content;
`;
const Base = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 115vh;
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    /* overflow: hidden; */
    /* background-image: ${({ guest }) => (guest ? 'linear-gradient(to bottom right, #78C0E0, #6ad4de);' : 'none')}; */
    /* background: ${({ guest }) => (guest ? '#dde6d6' : '#f6f7f4')}; */
    background: #fffffe;
`;
const Window = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    padding: ${({ theme }) => theme.padding.xxlrg};
    box-sizing: border-box;
    width: 500px;
    max-width: 100%;
    min-height: 250px;
    max-height: 100%;
    background: white;
    border-radius: 5px;
    filter: drop-shadow(0 0 5px #0004);
    transition: 0.2s;
`;
const Area = styled.div`
    width: 100%;
    display: flex;
    flex-direction: ${props => (props.column ? 'column' : 'row')};
    justify-content: ${props => props.justify || 'flex-start'};
    padding: ${props => props.theme.padding.lrg};
    border-radius: 10px;
    background: ${props => (props.info ? props.theme.color[props.color] : 'inherit')};
    border: ${props => (props.borderColor ? `${props.theme.border.med} solid ${props.theme.color[props.borderColor]}` : 'none')}
`;
const Pad = styled.div`
    width: 100%;
    display: flex;
    padding: ${props => (props.V ? props.theme.padding[props.pad] : 0)} ${props => (props.H ? props.theme.padding[props.pad] : 0)};
`;
const CenterLine = styled.div`
    width: 100%;
    display: flex;
    justify-content: ${({ justify }) => (justify || 'center')};
    align-items: center;
    padding: ${({ theme }) => theme.padding.sm};
`;


Layout.Base = Base;
Layout.Horizontal = Horizontal;
Layout.Vertical = Vertical;
Layout.Reduced = Reduced;
Layout.Area = Area;
Layout.Pad = Pad;
Layout.Window = Window;
Layout.CenterLine = CenterLine;
export { Layout };



// WEBPACK FOOTER //
// ./src/sc-ui/Layout.jsx